module.exports = __webpack_public_path__ + "img/location.118c6d25.svg";